import { UnshadowedElement, html } from "../lib/unshadowed.js";

/**
 * Simple progress bar
 */
export class ProgressBar extends UnshadowedElement {
    static elementName() { return "progress-bar" }

    static properties = {
        percent: { type: Number },
    };

    render() {
        return html`
            <div class="progress-bar" style="--progress-bar-percent: ${this.percent}%"><div class="progress-bar__fill"></div></div>
        `;
    }
}
